<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.99 36.92">
        <path class="cls-1" d="M27.31,25a6.51,6.51,0,0,0-8.21.82A6.49,6.49,0,1,0,27.31,25ZM27,32.65a4,4,0,0,1-1.8,1.48,3.93,3.93,0,0,1-2.32.23,4,4,0,0,1-2.06-1.1,4,4,0,0,1-1.1-2A4.09,4.09,0,0,1,20,28.89,4,4,0,1,1,27,32.65Z" fill="white"/>
        <path class="cls-1" d="M16.28,28a5.49,5.49,0,0,1,.2-.57,7.74,7.74,0,0,1,1.69-2.54,7.62,7.62,0,0,1,2.53-1.7,7.86,7.86,0,0,1,3-.6v0a7.78,7.78,0,0,1,7.22,4.8q.12.28.21.57H47.4V1.5A1.5,1.5,0,0,0,45.9,0H1.5A1.5,1.5,0,0,0,0,1.5v25A1.5,1.5,0,0,0,1.5,28Z" fill="white"/>
        <path class="cls-1" d="M57.54,29.4H31.42l.06.56c0,.24,0,.49,0,.73s0,.21,0,.31c0,.32-.06.64-.12.95,0,.12-.07.22-.09.34h23v1a1.87,1.87,0,0,0-.34,0,1.82,1.82,0,1,0,1.82,1.81s0,0,0,0h0V32.29h1.84a1.45,1.45,0,1,0,0-2.89Z" fill="white"/>
        <path class="cls-1" d="M15.9,30.44a9.08,9.08,0,0,1,.07-1h-13v1.39a1.51,1.51,0,0,0,1.5,1.5H16.14c-.07-.3-.13-.59-.17-.89A7.61,7.61,0,0,1,15.9,30.44Z" fill="white"/>
    </svg>
</template>

<script>
export default {
    name: "IconTrailer"
}
</script>
